import React from "react";
/** Components Import */
import { Stack, TextField } from "@mui/material";

function FindId(props) {
	return (
		<>
			{props.findIdInputs.successful ? (
				<div>ID: {props.findIdInputs.userId}</div>
			) : (
				<Stack sx={{ my: 2 }} spacing={2}>
					<TextField
						sx={{ minWidth: 280 }}
						label={
							props.lanList.length > 0
								? props.lanList.filter(
										(f) => f.lanId === "Name"
								  )[0].lanNm
								: "" // 이름
						}
						value={props.findIdInputs.userNm}
						onChange={(e) => {
							props.setFindIdInputs({
								...props.findIdInputs,
								userNm: e.target.value,
							});
						}}
					/>
					<TextField
						sx={{ minWidth: 280 }}
						label={
							props.lanList.length > 0
								? props.lanList.filter(
										(f) => f.lanId === "Tel"
								  )[0].lanNm
								: "" // 전화번호
						}
						value={props.findIdInputs.userTel}
						type="tel"
						onChange={(e) => {
							props.setFindIdInputs({
								...props.findIdInputs,
								userTel: e.target.value
									.replace(/[^0-9]/g, "")
									.replace(
										/^(\d{0,3})(\d{0,4})(\d{0,4})$/g,
										"$1-$2-$3"
									)
									.replace(/(\-{1,2})$/g, ""),
							});
						}}
					/>
				</Stack>
			)}
		</>
	);
}

export default FindId;
